import cx from 'classnames'

import { Carousel } from '@/components/Carousel'
import type { Space } from '@/components/Container'
import { Image } from '@/components/Image'
import { HeadingL } from '@/components/Typography'
import type { TitleProps } from '@/models'
import type { BuilderImage } from '@/models/BuilderImage'

import {
  ProductCarouselBackground,
  ProductCarouselCards,
  ProductCarouselContainer,
  ProductCarouselContent,
  Subtitle,
} from './styles'

interface BuilderCard {
  image?: BuilderImage
}

interface ProductCarouselProps {
  id?: string
  title: TitleProps
  subtitle?: TitleProps
  cards: BuilderCard[] | undefined
  space: Space
}

const ProductCarousel = ({ id, title, subtitle, cards, space = 'm' }: ProductCarouselProps) => {
  const isThereAnyCards = cards && cards.length > 0
  return (
    <ProductCarouselBackground
      className={cx({
        [`eu-sm-${space}`]: space,
      })}
    >
      <ProductCarouselContainer id={id}>
        <ProductCarouselContent>
          <HeadingL tag={title.tag || 'h3'}>{title.text}</HeadingL>
          {subtitle && <Subtitle tag={subtitle.tag || 'p'}>{subtitle.text}</Subtitle>}
        </ProductCarouselContent>
        {isThereAnyCards && (
          <ProductCarouselCards>
            <Carousel>
              {cards.map((card, index) => {
                if (card.image) {
                  return (
                    <Image
                      source={card.image.url}
                      alt={card.image.alt}
                      width={302}
                      height={448}
                      layout="fixed"
                      key={index}
                    />
                  )
                }
                return null
              })}
            </Carousel>
          </ProductCarouselCards>
        )}
      </ProductCarouselContainer>
    </ProductCarouselBackground>
  )
}
export default ProductCarousel
